import type { GroupCreationAttribution, GroupCreationSource } from '@/types/groups';

const SOURCES = new Set<GroupCreationSource>(['direct', 'quiz_results', 'group_results', 'group_reveal', 'group_retake']);

/** Normalize optional UI context. This is not server authorization. */
export function parseCreationAttribution(value: unknown): GroupCreationAttribution | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return undefined;
  const candidate = value as Record<string, unknown>;
  if (!SOURCES.has(candidate.creationSource as GroupCreationSource)) return undefined;
  const creationSource = candidate.creationSource as GroupCreationSource;
  const needsParent = creationSource.startsWith('group_');
  if (!needsParent) return candidate.parentGroupId == null ? { creationSource } : undefined;
  return typeof candidate.parentGroupId === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(candidate.parentGroupId)
    ? { creationSource, parentGroupId: candidate.parentGroupId }
    : undefined;
}
